import createAction from 'redux-actions/lib/createAction';

export const SET_SUBJECT = 'contactUsActions/SET_SUBJECT';
export const setSubject = createAction(SET_SUBJECT);

export const SET_MAP_VISIBLE = 'contactUsActions/SET_MAP_VISIBLE';
export const setMapVisible = createAction(SET_MAP_VISIBLE);
